"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toDayOfWeek = exports.toCivilianTime = exports.sortAndSplitHours = exports.getOpeningHoursText = exports.formatTime = exports.formatHour = exports.currentTimeIsBetween = exports.combineHours = void 0;

var _dateFns = require("date-fns");

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var formatHour = function formatHour(hour) {
  return hour.substring(0, 5);
};

exports.formatHour = formatHour;

var toDayOfWeek = function toDayOfWeek(dayOfWeekNumber) {
  var _dayMapping$dayOfWeek;

  var dayMapping = {
    1: "Mon",
    2: "Tue",
    3: "Wed",
    4: "Thur",
    5: "Fri",
    6: "Sat",
    7: "Sun"
  };
  return dayOfWeekNumber ? (_dayMapping$dayOfWeek = dayMapping[dayOfWeekNumber]) !== null && _dayMapping$dayOfWeek !== void 0 ? _dayMapping$dayOfWeek : "Sun" : "Sun";
};

exports.toDayOfWeek = toDayOfWeek;

var toCivilianTime = function toCivilianTime(time) {
  if (time) {
    var _time$split = time.split(":"),
        _time$split2 = _slicedToArray(_time$split, 2),
        hour = _time$split2[0],
        minute = _time$split2[1];

    hour = parseInt(hour, 10);
    var suffix = hour >= 12 ? "PM" : "AM";
    return "".concat((hour + 11) % 12 + 1, ":").concat(minute, " ").concat(suffix);
  }
};

exports.toCivilianTime = toCivilianTime;

var sortAndSplitHours = function sortAndSplitHours(obj) {
  var splitBySequence = function splitBySequence(items, differences) {
    return items.reduce(function (memo, item) {
      var lastArray = memo[memo.length - 1];
      var lastItem = lastArray[lastArray.length - 1];

      if (!lastItem || differences.includes(item - lastItem)) {
        lastArray.push(item);
      } else {
        memo.push([item]);
      }

      return memo;
    }, [[]]);
  };

  var getFlankDays = function getFlankDays(k) {
    if (k.length > 1) {
      return [toDayOfWeek(k[0]), toDayOfWeek(k[k.length - 1])].join("-");
    }

    return toDayOfWeek(k[0]);
  };

  var x = Object.entries(obj).reduce(function (accu, i) {
    var daysInSequence = splitBySequence(i[1], [1, -6]);
    return [].concat(_toConsumableArray(accu), _toConsumableArray(daysInSequence.map(function (x) {
      return {
        order: x[0] ? x[0] : 7,
        days: x,
        text: getFlankDays(x),
        hours: i[0]
      };
    })));
  }, []).sort(function (a, b) {
    return a.order - b.order;
  });
  return x;
};

exports.sortAndSplitHours = sortAndSplitHours;

var formatTime = function formatTime(min) {
  var hours = 0;
  var minutes = 0;

  if (min) {
    hours = Math.floor(min / 60);
    minutes = min % 60;
  }

  var values = [];

  if (hours) {
    values.push("".concat(hours, " ").concat(hours > 1 ? "hours" : "hour"));
  }

  if (minutes) {
    values.push("".concat(minutes, " ").concat(minutes > 1 ? "minutes" : "minute"));
  }

  return values.join(" and ");
};

exports.formatTime = formatTime;

var combineHours = function combineHours(hours) {
  if (!hours) return {
    delivery: [],
    kiosk: [],
    pickup: []
  };
  var hoursObject = hours.reduce(function (accu, i) {
    if (!i.deliveryOpen && !i.deliveryClose) {
      accu.delivery.Closed = [].concat(_toConsumableArray(accu.delivery.Closed || []), [i.day]);
    } else {
      var deliveryOpen = toCivilianTime(formatHour(i.deliveryOpen));
      var deliveryClose = toCivilianTime(formatHour(i.deliveryClose));

      if (accu.delivery["".concat(deliveryOpen, " - ").concat(deliveryClose)]) {
        accu.delivery["".concat(deliveryOpen, " - ").concat(deliveryClose)].push(i.day);
      } else {
        accu.delivery["".concat(deliveryOpen, " - ").concat(deliveryClose)] = [i.day];
      }
    }

    if (!i.pickupOpen && !i.pickupClose) {
      accu.pickup.Closed = [].concat(_toConsumableArray(accu.pickup.Closed || []), [i.day]);
    } else {
      var pickupOpen = toCivilianTime(formatHour(i.pickupOpen));
      var pickupClose = toCivilianTime(formatHour(i.pickupClose));

      if (accu.pickup["".concat(pickupOpen, " - ").concat(pickupClose)]) {
        accu.pickup["".concat(pickupOpen, " - ").concat(pickupClose)].push(i.day);
      } else {
        accu.pickup["".concat(pickupOpen, " - ").concat(pickupClose)] = [i.day];
      }
    }

    if (!i.dineInOpen && !i.dineInClose) {
      accu.kiosk.Closed = [].concat(_toConsumableArray(accu.kiosk.Closed || []), [i.day]);
    } else {
      var dineInOpen = toCivilianTime(formatHour(i.dineInOpen));
      var dineInClose = toCivilianTime(formatHour(i.dineInClose));

      if (accu.kiosk["".concat(dineInOpen, " - ").concat(dineInClose)]) {
        accu.kiosk["".concat(dineInOpen, " - ").concat(dineInClose)].push(i.day);
      } else {
        accu.kiosk["".concat(dineInOpen, " - ").concat(dineInClose)] = [i.day];
      }
    }

    return accu;
  }, {
    delivery: {},
    pickup: {},
    kiosk: {}
  });
  return {
    delivery: sortAndSplitHours(hoursObject.delivery),
    pickup: sortAndSplitHours(hoursObject.pickup),
    kiosk: sortAndSplitHours(hoursObject.kiosk)
  };
};

exports.combineHours = combineHours;

var getOpeningHoursText = function getOpeningHoursText(diningOptionHours) {
  var storeHours = diningOptionHours === null || diningOptionHours === void 0 ? void 0 : diningOptionHours.hours.split("-");
  var openingHoursText = "Open from ".concat(storeHours === null || storeHours === void 0 ? void 0 : storeHours[0], " to ").concat(storeHours === null || storeHours === void 0 ? void 0 : storeHours[1]);

  if ((diningOptionHours === null || diningOptionHours === void 0 ? void 0 : diningOptionHours.hours) === "Closed") {
    openingHoursText = "Currently closed, opens in ".concat(diningOptionHours.hoursUntilOpen, " hour(s)");
  }

  return openingHoursText;
};

exports.getOpeningHoursText = getOpeningHoursText;

var currentTimeIsBetween = function currentTimeIsBetween(startTime, endTime) {
  var currentDate = new Date();
  var startTimeDate = (0, _dateFns.parse)(startTime === null || startTime === void 0 ? void 0 : startTime.trim(), "hh:mm aa", currentDate);
  var endTimeDate = (0, _dateFns.parse)(endTime === null || endTime === void 0 ? void 0 : endTime.trim(), "hh:mm aa", currentDate);
  var start = startTimeDate.getTime();
  var end = endTimeDate.getTime();
  var current = currentDate.getTime();

  if (start <= end) {
    return current >= start && current <= end;
  } //When the startTime is greater than endTime, that means endTime is the next day


  end = (0, _dateFns.addDays)(endTimeDate, 1).getTime();
  return current >= start && current <= end;
};

exports.currentTimeIsBetween = currentTimeIsBetween;